import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SectionProps, WithRefProps } from '../types';

interface FAQSectionProps extends SectionProps, WithRefProps {
  handleCTAClick: (e: React.MouseEvent) => void;
}

const FAQSection: React.FC<FAQSectionProps> = ({ inView, forwardedRef, handleCTAClick }) => {
  return (
    <section id="faq" className="section-padding bg-white">
      <div ref={forwardedRef} className={`container fade-up ${inView ? 'in-view' : ''}`}>
        <div className="text-center mb-12">
          <h2 className="mb-4">
            Ihre Fragen, Beantwortet
          </h2>
        </div>
        
        <div className="max-w-3xl mx-auto space-y-4">
          <details className="bg-white rounded-lg shadow-md overflow-hidden">
            <summary className="px-6 py-4 flex items-center justify-between cursor-pointer font-medium text-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-secondary-200 text-primary-500 rounded-full flex items-center justify-center flex-shrink-0">?</div>
                <span>Was ist die kostenlose Potentialanalyse?</span>
              </div>
              <span className="text-primary-500">
                <ArrowRight size={18} className="transform transition-transform" />
              </span>
            </summary>
            <div className="px-6 py-4 border-t border-gray-100">
              <p>
                Eine unverbindliche Beratung, bei der wir Ihre aktuellen Benefits bewerten und zeigen, wie deren Verbesserung Krankheitstage und Fluktuation reduzieren kann.
              </p>
            </div>
          </details>
          
          <details className="bg-white rounded-lg shadow-md overflow-hidden">
            <summary className="px-6 py-4 flex items-center justify-between cursor-pointer font-medium text-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-secondary-200 text-primary-500 rounded-full flex items-center justify-center flex-shrink-0">?</div>
                <span>Ist dieses Programm für kleine Unternehmen geeignet?</span>
              </div>
              <span className="text-primary-500">
                <ArrowRight size={18} className="transform transition-transform" />
              </span>
            </summary>
            <div className="px-6 py-4 border-t border-gray-100">
              <p>
                Ja - es ist skalierbar. Auch ein kleines Team kann stark von maßgeschneiderten Gesundheits- und Vorsorgelösungen profitieren, die die Moral stärken.
              </p>
            </div>
          </details>
          
          <details className="bg-white rounded-lg shadow-md overflow-hidden">
            <summary className="px-6 py-4 flex items-center justify-between cursor-pointer font-medium text-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-secondary-200 text-primary-500 rounded-full flex items-center justify-center flex-shrink-0">?</div>
                <span>Welche Benefits sind enthalten?</span>
              </div>
              <span className="text-primary-500">
                <ArrowRight size={18} className="transform transition-transform" />
              </span>
            </summary>
            <div className="px-6 py-4 border-t border-gray-100">
              <p>
                Typischerweise eine Mischung aus Gesundheits- und finanziellen Wellness-Benefits (z.B. zusätzliche Gesundheitsversorgung, Wellness-Programme, Zuschüsse zur Altersvorsorge), die auf Ihre Belegschaft zugeschnitten sind.
              </p>
            </div>
          </details>
          
          <details className="bg-white rounded-lg shadow-md overflow-hidden">
            <summary className="px-6 py-4 flex items-center justify-between cursor-pointer font-medium text-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-secondary-200 text-primary-500 rounded-full flex items-center justify-center flex-shrink-0">?</div>
                <span>Was kostet es?</span>
              </div>
              <span className="text-primary-500">
                <ArrowRight size={18} className="transform transition-transform" />
              </span>
            </summary>
            <div className="px-6 py-4 border-t border-gray-100">
              <p>
                Dank Steuervergünstigungen kann das Anbieten von Benefits sehr kosteneffektiv sein - wir schätzen Ihre Investition und den ROI während der kostenlosen Analyse ein.
              </p>
            </div>
          </details>
        </div>
        
        <div className="text-center mt-12">
          <button 
            onClick={handleCTAClick}
            className="btn btn-primary px-6 py-3 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:ring-opacity-50"
          >
            Weitere Fragen? Vereinbaren Sie ein Gespräch
            <ArrowRight size={20} className="ml-2" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;